import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Box from "@material-ui/core/Box";

// Custom Component
import Legend from "../../Legend/Legend";

import AttachmentChip from "../../Chip/AttachmentChip";

// Custom Style
import { rfiDetailFormStyle } from "../../../styles/jss/components/RFI/rfiDetailFormStyle";

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));

const TransmittalSelectRFIGI = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { noneditViewFileAction, downloadFileAction, transRFIValue } = props;

  return (
    <Fragment>
      <Grid item xs={12}>
        <>
          <Grid item xs={12}>
            <Typography variant="subtitle1">
              RFI Stage:
              <div className={classes.itemText}>{transRFIValue.stageName}</div>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1">
              RFI Reference Number:
              <div className={classes.itemText}>{transRFIValue.ref_no}</div>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1">
              Issued By:
              <div className={classes.itemText}>{transRFIValue.createuser}</div>
            </Typography>
            <hr className={classes.elementDivider} />
          </Grid>
          <Grid>
            <Legend id="file_attachment" label="ATTACHMENTS">
              <div className={classes.messageAttachmentArea}>
                <Grid item xs={12}>
                  {transRFIValue.rfi_attachments &&
                  transRFIValue.rfi_attachments.length > 0 ? (
                    transRFIValue.rfi_attachments.map((obj, index) => {
                      return (
                        <AttachmentChip
                          key={obj.file_seq}
                          id={obj.file_seq}
                          filename={obj.filename}
                          fileSize={obj.filesize}
                          fileExtension={obj.extension}
                          viewFileAction={() =>
                            noneditViewFileAction("rfi", obj.atth_seq)
                          }
                          downloadFileAction={() =>
                            downloadFileAction("rfi", obj.atth_seq)
                          }
                          fileRemoveAction={null}
                        />
                      );
                    })
                  ) : (
                    <h3 style={{ color: "red" }}>No attchments</h3>
                  )}
                </Grid>
              </div>
            </Legend>
          </Grid>
        </>
      </Grid>
    </Fragment>
  );
};

export default TransmittalSelectRFIGI;
